export default "__VITE_ASSET__CFWTXnF7__"